// extracted by css-extract-rspack-plugin
export default {"item":"cYaJnyWUV1oEajF4","redLevel":"TanpzilM5OYFk_Cx"};